import React from 'react'

import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Tooltip from '@mui/material/Tooltip'
import Link from '@mui/material/Link'
import ReactMarkdown from 'react-markdown'
import { IAlertBanner, IMarkdownText } from '../../AlertBanner'
import RichText from '../../RichText/RichText'
import { IRichText } from '../../RichText/types'

export const InlineAlert: React.FC<IAlertBanner> = ({ severity, body, title, description }) => {
  const markdownText = (description as IMarkdownText)?.description || (description as string)

  return (
    <Box sx={{ mb: 3 }}>
      <Alert severity={severity} variant="inline">
        {body && <RichText {...(body as IRichText)} />}
        {title && <AlertTitle>{title}</AlertTitle>}
        {description && (
          <ReactMarkdown
            components={{
              a: ({ children, href }) => {
                const url = href && href.replace(/(^\w+:|^)\/\//, '')
                return (
                  <Tooltip title={url}>
                    <Link href={href}>{children}</Link>
                  </Tooltip>
                )
              },
            }}
            children={markdownText}
          />
        )}
      </Alert>
    </Box>
  )
}
